import type { IconSvgObject } from './types';

const OrientationLandscapeToPotraitIcon: IconSvgObject = [
  ["path", { d: "M12 9V6C12 4.89543 11.1046 4 10 4H4C2.89543 4 2 4.89543 2 6V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 20V14C20 12.8954 19.1046 12 18 12L4 12C2.89543 12 2 12.8954 2 14L2 20C2 21.1046 2.89543 22 4 22L18 22C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 4.5H20C21.1046 4.5 22 5.39543 22 6.5V9.5M18.5 2L16 4.5L18.5 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default OrientationLandscapeToPotraitIcon;
